import { ThemeId, ThemeMode } from '@/interfaces/widgetTheme';
import { BASE } from './base';
import { SPACING } from './spacing';
import { FONTS, TYPOGRAPHY } from './variants/light/typography';
import { ELEMENTS } from './variants/light/elements';
import { COLOR, COLOR_PALLETS } from './variants/light/color';
import { ELEMENTS as DARK_ELEMENTS } from './variants/dark/elements';
import { TYPOGRAPHY as DARK_TYPOGRAPHY } from './variants/dark/typography';
import { COLOR as DARK_COLOR, COLOR_PALLETS as DARK_COLOR_PALLETS } from './variants/dark/color';
export default {
  id: ThemeId.UniversalDesign,
  name: 'Default',
  shared: true,
  base: BASE,
  fonts: FONTS,
  typography: TYPOGRAPHY,
  spacing: SPACING,
  color: COLOR,
  colorPallets: COLOR_PALLETS,
  elements: ELEMENTS,
  variants: {
    [ThemeMode.Dark]: {
      color: DARK_COLOR,
      colorPallets: DARK_COLOR_PALLETS,
      elements: DARK_ELEMENTS,
      typography: DARK_TYPOGRAPHY
    }
  }
};